/**
 * @generated SignedSource<<ad6059e1cd192f90a9374684f30c0736>>
 * @relayHash a88765aa84a1f3f691dc9b886dc374f6
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID aef93d76fabc4d20e1956e25f716eff5d2f5dfa8e3dc5f571b60cd4f41248e4b

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventAttendeeStatus = "ATTENDING_IN_PERSON" | "ATTENDING_VIRTUAL" | "NOT_ATTENDING" | "PENDING_APPROVAL" | "WAITING_IN_PERSON" | "WAITING_VIRTUAL" | "%future added value";
export type AttendEventInput = {
  clientMutationId?: string | null | undefined;
  eventId?: string | null | undefined;
  formSubmissionId?: string | null | undefined;
  status?: EventAttendeeStatus | null | undefined;
};
export type EventAttendButtonHybridAttendMutation$variables = {
  input: AttendEventInput;
};
export type EventAttendButtonHybridAttendMutation$data = {
  readonly attendEvent: {
    readonly event: {
      readonly " $fragmentSpreads": FragmentRefs<"EventItemNew_event">;
    } | null | undefined;
  } | null | undefined;
};
export type EventAttendButtonHybridAttendMutation = {
  response: EventAttendButtonHybridAttendMutation$data;
  variables: EventAttendButtonHybridAttendMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v7 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v8 = {
  "kind": "Literal",
  "name": "fit",
  "value": "cover"
},
v9 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v10 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "membershipLevel",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v7/*: any*/),
            (v8/*: any*/),
            {
              "kind": "Literal",
              "name": "fo",
              "value": "face"
            },
            (v9/*: any*/),
            (v10/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "transform"
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"face\",\"h\":100,\"w\":100})"
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": [
    {
      "fields": [
        (v7/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/)
      ],
      "kind": "ObjectValue",
      "name": "transform"
    }
  ],
  "kind": "ScalarField",
  "name": "defaultAvatarUrl",
  "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"h\":100,\"w\":100})"
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v19 = [
  (v12/*: any*/),
  (v13/*: any*/),
  (v3/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v4/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v21 = [
  (v18/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventAttendButtonHybridAttendMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AttendEventPayload",
        "kind": "LinkedField",
        "name": "attendEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventItemNew_event"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventAttendButtonHybridAttendMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AttendEventPayload",
        "kind": "LinkedField",
        "name": "attendEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "prettyUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasExternalUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasVenue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visibility",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "coverPhoto",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": "mobileTransformUrl",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "transform",
                        "value": {
                          "dpr": 3,
                          "w": 576
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":576})"
                  },
                  {
                    "alias": "desktopTransformUrl",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "transform",
                        "value": {
                          "dpr": 3,
                          "w": 200
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":200})"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "eventOwner",
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "primaryPhoto",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "fields": [
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "kind": "ObjectValue",
                                "name": "transform"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "transformUrl",
                            "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GuildMembership",
                        "kind": "LinkedField",
                        "name": "myMembership",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "type": "Guild",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isMe",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/)
                    ],
                    "type": "User",
                    "abstractKey": null
                  },
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "attendeesByRelevance",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "status": {
                        "in": [
                          "ATTENDING_IN_PERSON",
                          "ATTENDING_VIRTUAL",
                          "WAITING_IN_PERSON",
                          "WAITING_VIRTUAL"
                        ]
                      }
                    }
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 8
                  }
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventAttendeesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventAttendee",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": (v19/*: any*/),
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:8)"
              },
              {
                "alias": "attendingCount",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "status": {
                        "in": [
                          "ATTENDING_IN_PERSON",
                          "ATTENDING_VIRTUAL"
                        ]
                      }
                    }
                  }
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v21/*: any*/),
                "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}})"
              },
              {
                "alias": "waitingCount",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "status": {
                        "in": [
                          "WAITING_IN_PERSON",
                          "WAITING_VIRTUAL"
                        ]
                      }
                    }
                  }
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v21/*: any*/),
                "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}})"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": [
                      "SORT_ORDER_ASC",
                      "CREATED_AT_ASC"
                    ]
                  }
                ],
                "concreteType": "EventTicketingTiersConnection",
                "kind": "LinkedField",
                "name": "eventTicketingTiers",
                "plural": false,
                "selections": (v21/*: any*/),
                "storageKey": "eventTicketingTiers(orderBy:[\"SORT_ORDER_ASC\",\"CREATED_AT_ASC\"])"
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventAttendee",
                "kind": "LinkedField",
                "name": "myAttendance",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paymentStatus",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GuildMembership",
                        "kind": "LinkedField",
                        "name": "myMembership",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v22/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Guild",
                    "abstractKey": null
                  },
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Form",
                "kind": "LinkedField",
                "name": "attendeeForm",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": "eventItemPresentations",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": [
                      "CREATED_AT_ASC",
                      "ID_ASC"
                    ]
                  }
                ],
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PresentationsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Presentation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "presenterFirstName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "presenterLastName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "presenter",
                            "plural": false,
                            "selections": (v19/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "transform",
                                "value": {
                                  "dpr": 3,
                                  "h": 24,
                                  "w": 24
                                }
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "guestPresenterAvatarUrl",
                            "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"h\":24,\"w\":24})"
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "presentations(orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "aef93d76fabc4d20e1956e25f716eff5d2f5dfa8e3dc5f571b60cd4f41248e4b",
    "metadata": {},
    "name": "EventAttendButtonHybridAttendMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b3542d2176217b2e64375a477296fc21";

export default node;
